import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import { FormattedDate } from "react-intl";
import { FormattedNumber } from "../FormattedNumber/FormattedNumber";

import CircularProgress from "../CircularProgress/CircularProgress";
import ModalSpotQuote from "./Modal";
import { localDateTime, showDateTime } from "../../utils/Helper";

const SpotQuotes = ({ services }) => {
  const [quotes, setQuotes] = useState(undefined);
  const [modalEdit, setModalEdit] = useState({
    open: false,
    quote: undefined,
    loading: false,
  });

  const handleEditQuote = (quote) => {
    setModalEdit({
      open: true,
      quote,
      loading: false,
    });
  };

  const handleCloseModal = () => {
    setModalEdit({
      open: false,
      quote: undefined,
      loading: false,
    });
  };

  const handleAddQuote = (quote) => {
    setModalEdit((m) => ({ ...m, loading: true }));
    services
      .setSpotQuote({ pairprice: { ...quote } })
      .then(() => {
        setModalEdit({
          open: false,
          quote: undefined,
          loading: false,
        });
        setQuotes(undefined);
      })
      .catch(() => {
        setModalEdit((m) => ({
          ...m,
          loading: false,
        }));
      });
  };

  const closeBar = () => {
    document.body.classList.toggle("aside-menu-hidden");
  };

  useEffect(() => {
    if (!quotes) {
      services
        .getSpotQuotes({})
        .then((res) => {
          if (res) {
            setQuotes(res.pairprices);
          } else {
            setQuotes([]);
          }
        })
        .catch(() => {
          setQuotes([]);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quotes]);

  return (
    <React.Fragment>
      <aside className="aside-menu">
        <div className="callout m-0 py-2 text-muted text-center bg-light text-uppercase">
          <small>
            <b>Currency Quotes</b>
          </small>
        </div>
        <div className="aside-content">
          <hr className="transparent mx-3 my-0" />
          {!quotes && <CircularProgress sm />}
          {quotes &&
            quotes.map((q, i) => {
              let quoteDate = localDateTime(q.PairPriceDate);
              return (
                <React.Fragment key={q.PairPriceDescription}>
                  <div className="callout callout-primary m-0 py-3">
                    <div>
                      {q.PairPriceDescription}
                      {" - "}
                      <strong>
                        <FormattedNumber
                          value={q.PairPricePrice}
                          decimalScale={q.SubAssetClassDecimalPlaces}
                          dataTypeDecimalName="price"
                        />
                      </strong>
                    </div>
                    <small className="text-muted">
                      {quoteDate instanceof Date && !isNaN(quoteDate) && <FormattedDate value={quoteDate} />}
                    </small>
                  </div>
                  {i < quotes.length - 1 && <hr className="my-0" />}
                </React.Fragment>
              );
            })}
        </div>
        <button className="aside-minimizer" type="button" onClick={closeBar} />
      </aside>
      {modalEdit.open && (
        <ModalSpotQuote handleClose={handleCloseModal} {...modalEdit} handleSave={handleAddQuote} />
      )}
    </React.Fragment>
  );
};

export default SpotQuotes;
